import { useEffect, useState } from "react";
import { WhatsAppCampaignAPI } from "src/services/WhatsAppCampaignAPI";
import type { WhatsAppAudienceState } from "../WhatsAppCampaignTypes";

const IDLE_AUDIENCE: WhatsAppAudienceState = {
  status: "idle",
  columns: [],
  recipientCount: null,
  invalidPhoneCount: null,
};

const PHONE_COLUMN = "phone_number";

export const useWhatsAppAudience = (listNames: string[], enabled: boolean) => {
  const [audience, setAudience] = useState(IDLE_AUDIENCE);

  useEffect(() => {
    if (!enabled || !listNames.length) {
      setAudience(IDLE_AUDIENCE);
      return undefined;
    }

    let isStale = false;
    setAudience({ ...IDLE_AUDIENCE, status: "loading" });

    WhatsAppCampaignAPI.fetchAudienceColumns(listNames)
      .then(response => {
        if (isStale) {
          return;
        }
        setAudience(
          response.success
            ? {
                status: "success",
                columns: (response.columns ?? []).filter(column => column !== PHONE_COLUMN),
                recipientCount: response.row_count ?? null,
                invalidPhoneCount: response.invalid_phone_count ?? null,
              }
            : { ...IDLE_AUDIENCE, status: "error" }
        );
      })
      .catch(() => {
        if (!isStale) {
          setAudience({ ...IDLE_AUDIENCE, status: "error" });
        }
      });

    return () => {
      isStale = true;
    };
  }, [enabled, listNames]);

  return audience;
};
